import { css } from '@emotion/react';
import { Placement } from '@floating-ui/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { useTooltip, Text, Chip } from '@frontend/design-system';

type ResponseSourceTooltipProps = {
  title: string;
  hasError: boolean;
  hoverText: string;
  placement: Placement;
};

export const ResponseSourceTooltip = ({ title, hoverText, placement, hasError }: ResponseSourceTooltipProps) => {
  const { tooltipProps, triggerProps, Tooltip } = useTooltip({ placement });

  const color = hasError ? theme.colors.critical50 : theme.colors.success50;
  const iconName = hasError ? 'x-small' : 'check-small';
  const chipVariant = hasError ? 'critical' : 'success';

  return (
    <>
      <Chip key={title} variant={chipVariant} {...triggerProps}>
        <div css={badgeCSS}>
          <Icon style={{ color }} name={iconName} />
          <Text size='medium' style={{ color }}>
            {title}
          </Text>
        </div>
      </Chip>
      {hoverText && <Tooltip {...tooltipProps}>{hoverText}</Tooltip>}
    </>
  );
};

const badgeCSS = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
`;
